import Vue from 'vue'
import './pollyfills'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import VueNotify from 'vue-notifyjs'
import VeeValidate from 'vee-validate'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import App from './App.vue'
import UUID from 'vue-uuid'
import firebase from 'firebase'
import VTooltip from 'v-tooltip'

// Plugins
import GlobalComponents from './gloablComponents'
import GlobalDirectives from './globalDirectives'
import SideBar from './components/UIComponents/SidebarPlugin'

import VueQrcode from '@xkeshi/vue-qrcode'

// router setup
import routes from './routes/routes'

// library imports

import './assets/sass/paper-dashboard.scss'
import './assets/sass/element_variables.scss'
import './assets/sass/demo.scss'

import Gravatar from 'vue-gravatar'

import sidebarLinks from './sidebarLinks'

// The Plugin API gives you access to the ErrorBag prototype.
VeeValidate.use(({ ErrorBag }) => {
  // get the original method.
  const first = ErrorBag.prototype.first
  ErrorBag.prototype.first = function (...args) {
    // call it after binding it to the error bag instance.
    const msg = first.bind(this)(...args)
    // if there is a message returned, change the style.
    if (msg) {
      // TODO: we might need a better regex.
      return msg.replace(/^The .+field/i, 'This field')
    }

    return msg
  }
})

// plugin setup
Vue.use(VueRouter)
Vue.use(VueResource)
Vue.use(GlobalDirectives)
Vue.use(GlobalComponents)
Vue.use(VueNotify)
Vue.use(SideBar, {sidebarLinks: sidebarLinks})
Vue.use(VeeValidate)
Vue.use(UUID)
Vue.use(VTooltip)
Vue.component('qrcode', VueQrcode)
Vue.component('v-gravatar', Gravatar)
locale.use(lang)

// configure router
const router = new VueRouter({
  mode: 'history',
  routes, // short for routes: routes
  linkActiveClass: 'active'
})

router.beforeEach((to, from, next) => {
  // check to see if route requires auth
  if (to.matched.some(rec => rec.meta.requiresAuth)) {
    // check auth stat of user
    let user = firebase.auth().currentUser
    if (user) {
      // user signed in, proceed to route
      next()
    } else {
      // no user signed in, redirect to login
      next({ name: 'Login' })
    }
  } else {
    next()
  }
})

let app = null

// wait for firebase auth to init before creating the app
firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    /* eslint-disable no-new */
    app = new Vue({
      el: '#app',
      render: h => h(App),
      router
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js